export const getPricing = (): string => {
    return '$69';
}